<template>
  <div class="auth-wrapper">
    <div class="auth-container d-flex primary">
      <div class="logo-container">
        <div class="logo">
          <img src="@/assets/logos/cdseo-logo-white.png" />
        </div>
      </div>

      <div class="content-container">
        <div class="logo-container-sm">
          <div class="logo">
            <img src="@/assets/icon.png" />
          </div>
        </div>
        <div
          style="width: 100%"
        >
          <div class="d-flex align-center justify-end mb-4">
            <v-btn
              v-if="$hasRole('SUPERUSER')"
              large
              outlined
              color="primary"
              class="mr-3"
              to="/admin"
            >
              <v-icon left>fa-solid fa-crown</v-icon>
              Admin
            </v-btn>
            <v-btn
              large
              outlined
              color="primary"
              @click="$store.dispatch('endSession')"
            >Sign Out</v-btn>
          </div>
          <div
            v-if="$store.getters.accounts.length"
            class="pt-6"
          >
            <h1 class="auth-title">
              Select a Workspace
            </h1>
            <v-list
              class="mt-5"
            >
              <v-row dense>
                <v-col 
                  v-for="account in accountList"
                    :key="account.id"
                    cols="12" sm="6" md="12" lg="6"
                >
                  <v-list-item
                    class="workspace-item"
                    :href="account.url"
                  >
                    <v-list-item-avatar tile color="transparent">
                      <account-avatar :name="account.name" :size="40" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-medium">{{ account.name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon small>fa-solid fa-chevron-right</v-icon>
                    </v-list-item-action>
                  </v-list-item>

                </v-col>
              </v-row>

            </v-list>
          </div>
          <div
            v-else
          >
            <h1 class="auth-title">
              You do not have access<br />to any workspaces.
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.workspace-item {
  border: 1px solid #ccc;
  border-radius: 8px;
}
.theme--dark .workspace-item {
  border: 1px solid #292929;
  border-radius: 8px;
}
.workspace-item:hover {
  border: 1px solid #0269A5;
  color: #0269A5 !important;
  cursor: pointer;
}
.workspace-item:hover .v-icon {
color: #0269A5 !important;
}
</style>

<script>
import AccountAvatar from '@/components/AccountAvatar.vue'

export default {
  components: {
    AccountAvatar
  },
  data () {
    return {
    }
  },
  computed: {
    accountList () {
      const host = window.location.host
      return this.$store.getters.accounts
        .map(account => {
          const url = `${window.location.protocol}//${account.subdomain}.${host.split('.').slice(1).join('.')}`
          return {
            ...account,
            url
          }
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    }
  }
}
</script>
